import { render, staticRenderFns } from "./Krip.vue?vue&type=template&id=59628992&"
import script from "./Krip.vue?vue&type=script&lang=js&"
export * from "./Krip.vue?vue&type=script&lang=js&"
import style0 from "./Krip.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports